import React, { createContext, useContext, useState, useCallback } from 'react';
import ToastContainer from '../components/common/ToastContainer';

/**
 * Contexto global de notificações. Antes, cada página chamava useToast()
 * e obtinha o SEU próprio estado local — os toasts eram adicionados a um
 * array que ninguém renderizava. Agora há um único estado partilhado e o
 * ToastContainer é montado uma vez pelo Provider.
 */
const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', duration = 4000) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type, duration }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
    return id;
  }, []);

  const removeToast = useCallback((id) => setToasts(prev => prev.filter(t => t.id !== id)), []);
  const success = useCallback((m, d) => addToast(m, 'success', d), [addToast]);
  const error = useCallback((m, d) => addToast(m, 'error', d), [addToast]);
  const warning = useCallback((m, d) => addToast(m, 'warning', d), [addToast]);
  const info = useCallback((m, d) => addToast(m, 'info', d), [addToast]);

  return (
    <ToastContext.Provider value={{ toasts, addToast, removeToast, success, error, warning, info }}>
      {children}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  );
};

export const useToastContext = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast tem de estar dentro de <ToastProvider>');
  return ctx;
};
